import { COUNTRY_CODES } from '@Saral-Influencer-Marketing/saral-utils/src/constants/country';

export const countriesCodes = COUNTRY_CODES || [];

export const countryOptions = countriesCodes.map((country) => ({
  label: country.name,
  value: country.name,
  code: country.code,
}));
